module.exports = __webpack_public_path__ + "img/stackslash-38-mobile.50b1f9f7.jpg";